import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";

interface LegalDisclaimerProps {
  className?: string;
  variant?: "default" | "subtle" | "outline" | "minimal";
}

export const LegalDisclaimer: React.FC<LegalDisclaimerProps> = ({ 
  className,
  variant = "default" 
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  const baseStyles = "text-[12px] leading-relaxed transition-all duration-500 font-medium relative group cursor-pointer animate-in fade-in slide-in-from-bottom-2";
  
  const variants = {
    default: "p-4 bg-slate-100 border border-slate-300 rounded-xl text-slate-900 text-center font-bold",
    subtle: "p-4 bg-slate-100 border border-slate-300 rounded-xl text-slate-900 text-center max-w-4xl mx-auto font-bold text-[12px] shadow-sm",
    outline: "p-3 border border-gray-300 rounded-xl bg-white text-gray-900 shadow-sm font-medium",
    minimal: "p-0 bg-transparent border-0 text-slate-500 text-[10px] text-center font-normal",
  };

  return (
    <div 
      className={cn(baseStyles, variants[variant], className)}
      onClick={() => setIsVisible(false)}
      title="Haz clic para ocultar"
    >
      <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <X className="h-3 w-3 text-slate-400" />
      </div>
      <p>
        <strong>Nota:</strong> El Agente Legal no proporciona asesoría legal ni determinaciones profesionales y no sustituye el criterio de un profesional legal calificado. El contenido generado por IA puede ser inexacto. Los usuarios son los únicos responsables de revisar, verificar y decidir si confían en cualquier resultado antes de tomar medidas.
      </p>
    </div>
  );
};

export default LegalDisclaimer;
